import { useState } from 'react';
import PropTypes from 'prop-types';
import logoBlue from 'assets/images/logo-blue.svg';
import { status } from 'constants/general';
import Loader from 'modules/shared/common/components/Loader';
import SectionDivider from 'modules/shared/common/components/SectionDivider';

import {
  LoginWrapper,
  LoginLogo,
  LoginInput,
  LoginValidationErrMsg,
  LoginBtn,
} from './LoginComponent.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const LoginComponent = ({ stringsData, userAuthenticationInfo, submitUserLoginData }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [usernameFieldValue, setUsernameFieldValue] = useState('');
  const [passwordFieldValue, setPasswordFieldValue] = useState('');
  const [showUsernameErrMsg, setShowUsernameErrMsg] = useState(false);
  const [showPasswordErrMsg, setShowPasswordErrMsg] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleInputFieldChange = (event, setStateFn) => {
    const { value } = event.target;

    setStateFn(value);
  };

  const handleSubmitBtnClick = () => {
    let isValidSubmission = true;

    if (usernameFieldValue === '') {
      setShowUsernameErrMsg(true);
      isValidSubmission = false;
    } else setShowUsernameErrMsg(false);

    if (passwordFieldValue === '') {
      setShowPasswordErrMsg(true);
      isValidSubmission = false;
    } else setShowPasswordErrMsg(false);

    if (isValidSubmission === false) return;

    submitUserLoginData(usernameFieldValue, passwordFieldValue);
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <LoginWrapper>
      <LoginLogo src={logoBlue} />
      <SectionDivider gap={80} />
      <LoginInput
        id="username-login-input"
        value={usernameFieldValue}
        placeholder={stringsData.login.emailFieldPlaceholder}
        onChange={event => handleInputFieldChange(event, setUsernameFieldValue)}
      />
      {showUsernameErrMsg && (
        <LoginValidationErrMsg>{stringsData.login.emailFieldValidationError}</LoginValidationErrMsg>
      )}
      <SectionDivider gap={25} />
      <LoginInput
        id="password-login-input"
        value={passwordFieldValue}
        placeholder={stringsData.login.passwordFieldPlaceholder}
        type="password"
        onChange={event => handleInputFieldChange(event, setPasswordFieldValue)}
      />
      {showPasswordErrMsg && (
        <LoginValidationErrMsg>
          {stringsData.login.passwordFieldValidationError}
        </LoginValidationErrMsg>
      )}
      <SectionDivider gap={45} />
      {(userAuthenticationInfo.status === status.FETCHING && (
        <Loader width={30} height={30} thickness={5} />
      )) || (
        <LoginBtn as="button" onClick={() => handleSubmitBtnClick()}>
          {stringsData.login.loginBtn}
        </LoginBtn>
      )}
    </LoginWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

LoginComponent.propTypes = {
  stringsData: PropTypes.shape({
    login: PropTypes.shape({
      emailFieldPlaceholder: PropTypes.string,
      emailFieldValidationError: PropTypes.string,
      passwordFieldPlaceholder: PropTypes.string,
      passwordFieldValidationError: PropTypes.string,
      loginBtn: PropTypes.string,
    }),
  }).isRequired,
  userAuthenticationInfo: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
  submitUserLoginData: PropTypes.func.isRequired,
};

LoginComponent.defaultProps = {};

export default LoginComponent;
